import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { updateCurrentAdminData } from '../../api/admin.api';
import AlertSnack from '../../components/Alert/AlertSnack';
import { useAuth } from '../../context/authContext';
import { Container, ContainerForm, Title, Title2 } from '../../styles/index.sty';

const MyAccount = () => {
  const { currentUser, setCurrentUser, config } = useAuth();
  const navigate = useNavigate();
  const [ first_name, setFirst_name ] = useState(currentUser.first_name);
  const [ last_name, setLast_name ] = useState(currentUser.last_name);
  const [ email, setEmail ] = useState(currentUser.email);
  const [ mobile_no, setMobile_no ] = useState(currentUser.mobile_no);
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const user_name = `${currentUser.first_name} ${currentUser.last_name}`;

  const adminUpdateHandler = async () => {

    try {
      // setLoading(true);
      const submit = await updateCurrentAdminData({ first_name, last_name, email, mobile_no, admin_id: currentUser.admin_id}, config)
      // navigate('/myaccount')
      setResponse(submit);
      setOpen(true);
      console.log(submit);
      if (submit.status === "success") {
        setCurrentUser({
          admin_token : submit.data.admnin_token,
          admin_id: submit.data.admin_id,
          first_name: submit.data.first_name,
          last_name: submit.data.last_name,
          mobile_no: submit.data.mobile_no,
          email: submit.data.email,
          user_type: submit.data.user_type
        });
        localStorage.setItem("adminHandi", JSON.stringify({
          admin_token : submit.data.admnin_token,
          admin_id: submit.data.admin_id,
          first_name: submit.data.first_name,
          last_name: submit.data.last_name,
          mobile_no: submit.data.mobile_no,
          email: submit.data.email,
          user_type: submit.data.user_type
        }));
      }
      console.log('done')
    } catch {
      console.log("Failed to login");
    }
    setLoading(false)
  }

  return (
    <>
    <Container>
      <Title variant='h3' className='w-[100%]'>Welcome {user_name}</Title>
      <ContainerForm>
    {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="dashboard"/>}
      <Title2 variant='h5'>Update Your Info.</Title2>

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="first_name">First Name: </InputLabel>
          <OutlinedInput
            name="first_name"
            id="first_name"
            type="text"
            value={first_name}
            onChange={(e) => setFirst_name(e.target.value)}
            />
            <InputLabel htmlFor="last_name">Last Name: </InputLabel>
            <OutlinedInput
              name="last_name"
              id="last_name"
              type="text"
              value={last_name}
              onChange={(e) => setLast_name(e.target.value)}
              />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="emial">E-mail: </InputLabel>
          <OutlinedInput
            name="emial"
            id="emial"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="mobile_no">Mobile Number: </InputLabel>
          <OutlinedInput
            name="mobile_no"
            id="mobile_no"
            type="number"
            value={mobile_no}
            onChange={(e) => setMobile_no(e.target.value)}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/dashboard")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={adminUpdateHandler}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
}

export default MyAccount